<template>
  <div :class="['my-4', $attrs.class]">
    <Select v-bind="{ ...$attrs, ...$props, options: computedOptions }" v-model="model" />
  </div>
</template>

<script>
import Select from "~/components/inputs/Select";
import { withModel } from "~/mixins/withModel";

export default {
  name: "BaseSelect",

  components: { Select },

  mixins: [withModel],
  inheritAttrs: false,

  props: {
    ...Select.props,
    labelKey: {
      type: String,
      default: "label",
    },

    valueKey: {
      type: String,
      default: "value",
    },
  },

  emits: ["select:option"],

  computed: {
    computedOptions() {
      if (!this.options) {
        return [];
      }

      return this.options.map((option) => ({
        label: option[this.labelKey],
        value: option[this.valueKey],
        disabled: option.disabled || false,
      }));
    },
  },

  watch: {
    model() {
      this.$emit(
        "select:option",
        this.options.find((o) => o[this.valueKey] === this.model)
      );
    },
  },
};
</script>
